import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: any) => ({
  dataWrap: {
    position: 'relative',
    '& .MuiDataGrid-root': {
      paddingTop: '40px !important',
      '& .MuiDataGrid-main': {
        '& .MuiDataGrid-columnHeader': {
          textTransform: 'capitalize !important',
        },
        "& ::-webkit-scrollbar": {
          width: "6px"
        },
        "& ::-webkit-scrollbar-track": {
          backgroundColor: "#f5f5f5"
        },
        "& ::-webkit-scrollbar-thumb": {
          borderRadius: "10px",
          boxShadow: "inset 0 0 6px rgba(0,0,0,.3)",
        },
        '& .MuiDataGrid-virtualScroller': {
          height: 'calc(100vh - 400px) !important',
          overflowY: 'auto !important',
        },
      }
    },
  },

  tableContainer: {
    borderCollapse: 'collapse'

  },

  tableHeading: {
    padding: '12px',
    textAlign: 'left',
    backgroundColor: '#D9D9D9',
    borderColor: '#D9D9D9',
    borderCollapse: 'collapse'
  },

  tableCell: {
    padding: '12px',
    textAlign: 'center',
    backgroundColor: '#F6F6F6',
    borderColor: '#F6F6F6',
    borderCollapse: 'collapse',
    width: '24px'
  },


  overlay: {
    background: '#e9e9e9',
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    opacity: 0.5,
    zIndex: 998
  },
  loader: {
    position: 'absolute',
    border: '4px solid #f3f3f3',
    borderRadius: '50%',
    borderTop: '4px solid #eb0a1e',
    borderBottom: '4px solid #eb0a1e',
    borderLeft: '4px solid #eb0a1e',
    width: '120px',
    height: '120px',
    top: '50%',
    left: '40%',
    transform: `translate(-50%, -50%)`,
    webkitAnimation: '$spin 2s linear infinite',
    animation: '$spin 2s linear infinite'
  },


  "@-webkit-keyframes spin": {
    '0%': { "-webkit-transform": 'rotate(0deg)' },
    '100%': { "-webkit-transform": 'rotate(360deg)' }
  },


  "@keyframes spin": {
    '0%': { transform: 'rotate(0deg)' },
    '100%': { transform: 'rotate(360deg)' }
  },
}));